export default __webpack_public_path__ + "static/media/nodata-found.674fae2d.svg";